/**
 * QualityBadge.tsx — бейдж текущего качества воспроизведения (Shadcn Badge).
 * Цвет зависит от уровня: 4K/2K = фиолетовый/синий, 1080p = голубой, 720p = зелёный, и т.д.
 */

import React from 'react';
import { Badge } from './ui/badge';
import { cn } from '../lib/utils';

interface QualityBadgeProps {
  quality: string;
}

function getQualityClass(quality: string): string {
  switch (quality) {
    case '2160p':
    case '4K':   return 'bg-purple-500 text-white border-transparent hover:bg-purple-500/90';
    case '1440p':
    case '2K':   return 'bg-blue-500 text-white border-transparent hover:bg-blue-500/90';
    case '1080p': return 'bg-cyan-500 text-white border-transparent hover:bg-cyan-500/90';
    case '720p':  return 'bg-green-500 text-white border-transparent hover:bg-green-500/90';
    case '480p':  return 'bg-yellow-500 text-black border-transparent hover:bg-yellow-500/90';
    case '360p':  return 'bg-red-500 text-white border-transparent hover:bg-red-500/90';
    default:      return 'bg-gray-600 text-gray-200 border-transparent';
  }
}

export const QualityBadge: React.FC<QualityBadgeProps> = ({ quality }) => (
  <Badge className={cn('font-mono tracking-wide', getQualityClass(quality))}>
    {quality}
  </Badge>
);
